module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 4253
// module chunks = 64